import { ILifeItem } from './types';

/** Palette for wheel sectors and settings. */
export const SECTOR_COLORS = [
  '#A9A9F5',
  '#C173C1',
  '#7FD1D5',
  '#3B4CC0',
  '#E60000',
  '#F2EA00',
  '#2CA02C',
  '#CFA401',
  '#FF6B9D',
  '#4CAF96',
  '#5B8DEF',
  '#9B59B6',
  '#E67E22',
  '#F4B942',
  '#27AE60',
  '#C00000',
  '#3498DB',
  '#E74C3C',
  '#1ABC9C',
  '#8E44AD',
];

export const DEFAULT_LIFE_ITEMS: ILifeItem[] = [
  { color: '#A9A9F5', title: 'Семья, родные', shortTitle: 'Семья' },
  { color: '#C173C1', title: 'Здоровье', shortTitle: 'Здоровье' },
  { color: '#7FD1D5', title: 'Друзья,  отношения с другими', shortTitle: 'Друзья' },
  { color: '#3B4CC0', title: 'Личностный рост, духовное развитие', shortTitle: 'Развитие' },
  { color: '#E60000', title: 'Карьера, бизнес, профессиональный рост', shortTitle: 'Карьера' },
  { color: '#F2EA00', title: 'Финансы, инвестиции, деньги', shortTitle: 'Финансы' },
  { color: '#2CA02C', title: 'Отдых, хобби, путешествие', shortTitle: 'Отдых' },
  { color: '#CFA401', title: 'Окружение, материальные ценности', shortTitle: 'Имущество' },
];

export const WHEEL_SECTOR_COUNT = 8;

export const DEFAULT_SECTOR_NAMES = DEFAULT_LIFE_ITEMS.map((item) => item.title);

export function sectorColor(index: number): string {
  return SECTOR_COLORS[index % SECTOR_COLORS.length];
}

export function buildShortTitle(title: string): string {
  const first = title.trim().split(/[,,]/)[0]?.trim();
  if (!first) return `Сектор`;
  return first.length > 14 ? `${first.slice(0, 14)}…` : first;
}
